var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "route-box user-help-teacher" }, [
    _c(
      "div",
      { staticClass: "ev-page-return" },
      [
        _c("router-link", { attrs: { to: { path: "setting" } } }, [
          _c("span", { staticClass: "el-icon-arrow-left" }),
          _vm._v("返回 ")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "userContent user-main" }, [
      _c("ul", { staticClass: "userNav" }, [
        _c(
          "li",
          {
            class: { navActive: _vm.navActive == 1 },
            on: {
              click: function($event) {
                return _vm.changeMenu(1)
              }
            }
          },
          [_c("span", [_vm._v("  常见问题")])]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            class: { navActive: _vm.navActive == 2 },
            on: {
              click: function($event) {
                return _vm.changeMenu(2)
              }
            }
          },
          [_c("span", [_vm._v("  指导手册")])]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "userDetail" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-collapse",
            {
              attrs: { accordion: "" },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-collapse-item",
                { attrs: { title: "1.如何获取学期信息？", name: "1" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            学期信息由省级管理员统一创建，学校可自动获取省级创建的学期信息，如果学校是后期添加的学校，需要手动点击［获取学期］来获取学期信息。\n            学校可在省级学期的基础上调整学期的开始和截止时间，但是开始和截止时间在省级设置的基础上不可超过2周。学校需要根据学校的实际情况标注哪个学期是当前学期。\n          "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "2.学校的年级如何生成？", name: "2" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            运营人员在收集学校信息时，会收集学校的办学类型（小学／初中／高中）和学制（五四制／六三制）；年级是由学校的办学类型和学制自动确定学校的具体年级。\n          "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "3.角色设置和用户授权的关系？", name: "3" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            首先需要在［角色设置］中添加角色，并赋予这个角色在不同系统中的功能（即菜单），同一个角色可同时赋予不同系统中的功能；然后在［用户授权］下添加职务，并未这个职务赋予相应的人员和角色。\n          "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "el-collapse-item",
                { attrs: { title: "4.如何修改密码？", name: "4" } },
                [
                  _c("div", { staticStyle: { "text-indent": "2em" } }, [
                    _vm._v(
                      "\n            点击右上角的头像，在［个人中心］菜单下［修改密码］中，可以修改密码。\n          "
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          "margin-bottom": "20px",
          "font-size": "20px",
          "font-weight": "800"
        }
      },
      [_c("span", [_vm._v("常见问题")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }